import {en} from "./translations.en";
import {fr} from "./translations.fr";

export const translations = {
  en: {
    changePassword: en,
  },
  fr: {
    changePassword: fr,
  },
};
